var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box" }, [
      _c("h2", { staticClass: "match-header" }, [
        _vm._v("Reference: " + _vm._s(_vm._f("capitalize")(_vm.title)))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "configuration-reference" },
        [
          _c(
            "md-card-content",
            { staticClass: "card-content" },
            [
              _vm.$route.params.reference != "interests" &&
              _vm.$route.params.reference != "wizard-content"
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-8" }, [
                      _c(
                        "div",
                        { staticClass: "button-section button-section-style" },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "md-raised md-accent md-white-color capitalize",
                              attrs: {
                                disabled: _vm.disabledBtn == 1 ? true : false
                              }
                            },
                            [
                              _c("md-dialog-confirm", {
                                attrs: {
                                  "md-active": _vm.allDeleteBtn,
                                  "md-title": "Delete Confirmation",
                                  "md-content": _vm.setContentForAllDelete
                                },
                                on: {
                                  "update:mdActive": function($event) {
                                    _vm.allDeleteBtn = $event
                                  },
                                  "update:md-active": function($event) {
                                    _vm.allDeleteBtn = $event
                                  },
                                  "md-confirm": _vm.removeAllRecord
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "md-remove md-remove-all",
                                  on: {
                                    click: function($event) {
                                      _vm.allDeleteBtn = true
                                    }
                                  }
                                },
                                [_vm._v("Delete All")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "md-raised md-accent md-white-color capitalize",
                              attrs: {
                                disabled: _vm.disabled == 1 ? true : false
                              }
                            },
                            [
                              _c("md-dialog-confirm", {
                                attrs: {
                                  "md-active": _vm.active,
                                  "md-title": "Delete Confirmation",
                                  "md-content": _vm.setContent
                                },
                                on: {
                                  "update:mdActive": function($event) {
                                    _vm.active = $event
                                  },
                                  "update:md-active": function($event) {
                                    _vm.active = $event
                                  },
                                  "md-confirm": _vm.removeRecord
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "md-remove",
                                  on: {
                                    click: function($event) {
                                      _vm.active = true
                                    }
                                  }
                                },
                                [_vm._v("Delete")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.$route.params.reference != "protopia-owner" &&
                          _vm.$route.params.reference != "wizard-content"
                            ? _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised md-accent md-white-color capitalize",
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.file.click()
                                    }
                                  }
                                },
                                [_vm._v("Load")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$route.params.reference == "filter-words" ||
                          _vm.$route.params.reference == "protopia-owner" ||
                          _vm.$route.params.reference == "wizard-content"
                            ? _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised md-accent md-white-color capitalize",
                                  on: {
                                    click: function($event) {
                                      return _vm.AddNewFilter()
                                    }
                                  }
                                },
                                [_vm._v("Add New")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$route.params.reference != "protopia-owner" &&
                          _vm.$route.params.reference != "wizard-content"
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href: _vm.CSVLink,
                                    title: "Download sample file",
                                    download: ""
                                  }
                                },
                                [
                                  _c(
                                    "md-button",
                                    {
                                      staticClass:
                                        "md-fab md-mini md-white-color downloadBtn"
                                    },
                                    [_c("i", { staticClass: "fa fa-download" })]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$route.params.reference != "protopia-owner" &&
                      _vm.$route.params.reference != "wizard-content"
                        ? _c("p", { staticStyle: { color: "#ff0000" } }, [
                            _vm._v(
                              " Note : Please upload maximum 5,000 record in single upload! "
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-sm-4" },
                      [
                        _c(
                          "md-field",
                          [
                            _c("md-input", {
                              attrs: {
                                name: "searchData",
                                placeholder: "Search..."
                              },
                              on: {
                                input: _vm.sanitizeSearchData,
                                keyup: _vm.searchDataFromList
                              },
                              model: {
                                value: _vm.searchData,
                                callback: function($$v) {
                                  _vm.searchData =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "searchData"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference == "education"
                ? _c(
                    "md-table",
                    { staticClass: "education-table" },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c(
                            "md-table-head",
                            { staticClass: "card-header" },
                            [
                              _c("md-checkbox", {
                                staticClass: "checkBox-visible",
                                attrs: { value: true },
                                on: {
                                  change: function($event) {
                                    return _vm.checkAllData()
                                  }
                                },
                                model: {
                                  value: _vm.checkAll,
                                  callback: function($$v) {
                                    _vm.checkAll = $$v
                                  },
                                  expression: "checkAll"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tCountry\n\t\t\t\t\t\t\t\t"
                            ),
                            _vm.countrySort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "country")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.countrySort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "country")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("College\n\t\t\t\t\t\t\t\t"),
                            _vm.collegeSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "college")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.collegeSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "college")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("\n\t\t\t\t\t\t\t\tCity\n\t\t\t\t\t\t\t\t"),
                            _vm.citySort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "city")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.citySort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "city")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("\n\t\t\t\t\t\t\t\tState\n\t\t\t\t\t\t\t\t"),
                            _vm.stateSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "state")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.stateSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "state")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(" Action ")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.configurationData, function(referenceData) {
                        return [
                          _c(
                            "tr",
                            {
                              key: referenceData._id,
                              staticClass: "md-table-row"
                            },
                            [
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c("md-checkbox", {
                                      attrs: { value: referenceData._id },
                                      on: {
                                        change: function($event) {
                                          return _vm.singleRowCheck()
                                        }
                                      },
                                      model: {
                                        value: _vm.singleCheckBox,
                                        callback: function($$v) {
                                          _vm.singleCheckBox = $$v
                                        },
                                        expression: "singleCheckBox"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.country
                                          ? referenceData.country
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.college
                                          ? referenceData.college
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.city
                                          ? referenceData.city
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.state
                                          ? referenceData.state
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              "reference-" +
                                              _vm.$route.params.reference +
                                              "/" +
                                              referenceData._id +
                                              "/edit",
                                            params: {
                                              reference:
                                                _vm.$route.params.reference,
                                              id: referenceData._id
                                            }
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _vm.configurationData.length == 0
                        ? [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { colspan: "6", align: "center" } },
                                [
                                  _c("md-empty-state", {
                                    staticClass: "table-no-record",
                                    attrs: {
                                      "md-label": "No Record Found",
                                      "md-description": ""
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference == "location"
                ? _c(
                    "md-table",
                    { staticClass: "location-table" },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c(
                            "md-table-head",
                            { staticClass: "card-header" },
                            [
                              _c("md-checkbox", {
                                staticClass: "checkBox-visible",
                                attrs: { value: true },
                                on: {
                                  change: function($event) {
                                    return _vm.checkAllData()
                                  }
                                },
                                model: {
                                  value: _vm.checkAll,
                                  callback: function($$v) {
                                    _vm.checkAll = $$v
                                  },
                                  expression: "checkAll"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tCountry\n\t\t\t\t\t\t\t\t"
                            ),
                            _vm.countrySort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "country")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.countrySort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "country")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("\n\t\t\t\t\t\t\t\tState\n\t\t\t\t\t\t\t\t"),
                            _vm.stateSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "state")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.stateSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "state")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("\n\t\t\t\t\t\t\t\tCity\n\t\t\t\t\t\t\t\t"),
                            _vm.citySort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "city")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.citySort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "city")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Latitude\n\t\t\t\t\t\t\t\t"),
                            _vm.latitudeSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "latitude")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.latitudeSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "latitude")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Longitude\n\t\t\t\t\t\t\t\t"),
                            _vm.longitudeSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "longitude")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.longitudeSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "longitude")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Population\n\t\t\t\t\t\t\t\t"),
                            _vm.populationSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "population")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.populationSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn(
                                        "desc",
                                        "population"
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(" Action ")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.configurationData, function(referenceData) {
                        return [
                          _c(
                            "tr",
                            {
                              key: referenceData._id,
                              staticClass: "md-table-row"
                            },
                            [
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c("md-checkbox", {
                                      attrs: { value: referenceData._id },
                                      on: {
                                        change: function($event) {
                                          return _vm.singleRowCheck()
                                        }
                                      },
                                      model: {
                                        value: _vm.singleCheckBox,
                                        callback: function($$v) {
                                          _vm.singleCheckBox = $$v
                                        },
                                        expression: "singleCheckBox"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.country
                                          ? referenceData.country
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.state
                                          ? referenceData.state
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.city
                                          ? referenceData.city
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.latitude
                                          ? referenceData.latitude
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.longitude
                                          ? referenceData.longitude
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.population
                                          ? referenceData.population
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              "reference-" +
                                              _vm.$route.params.reference +
                                              "/" +
                                              referenceData._id +
                                              "/edit",
                                            params: {
                                              reference:
                                                _vm.$route.params.reference,
                                              id: referenceData._id
                                            }
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _vm.configurationData.length == 0
                        ? [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { colspan: "8", align: "center" } },
                                [
                                  _c("md-empty-state", {
                                    staticClass: "table-no-record",
                                    attrs: {
                                      "md-label": "No Record Found",
                                      "md-description": ""
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference == "organization"
                ? _c(
                    "md-table",
                    { staticClass: "organization-table" },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c(
                            "md-table-head",
                            { staticClass: "card-header" },
                            [
                              _c("md-checkbox", {
                                staticClass: "checkBox-visible",
                                attrs: { value: true },
                                on: {
                                  change: function($event) {
                                    return _vm.checkAllData()
                                  }
                                },
                                model: {
                                  value: _vm.checkAll,
                                  callback: function($$v) {
                                    _vm.checkAll = $$v
                                  },
                                  expression: "checkAll"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Name\n\t\t\t\t\t\t\t\t"),
                            _vm.nameSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "name")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.nameSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "name")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("\n\t\t\t\t\t\t\t\tURL\n\t\t\t\t\t\t\t\t"),
                            _vm.urlSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "url")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.urlSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "url")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tCategory\n\t\t\t\t\t\t\t\t"
                            ),
                            _vm.categorySort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "category")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.categorySort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "category")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tMarket\n\t\t\t\t\t\t\t\t"
                            ),
                            _vm.marketSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "market")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.marketSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "market")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tStatus\n\t\t\t\t\t\t\t\t"
                            ),
                            _vm.statusSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "status")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.statusSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "status")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tCountry\n\t\t\t\t\t\t\t\t"
                            ),
                            _vm.countrySort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "country")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.countrySort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "country")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tRegion\n\t\t\t\t\t\t\t\t"
                            ),
                            _vm.regionSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "region")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.regionSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "region")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("\n\t\t\t\t\t\t\t\tCity\n\t\t\t\t\t\t\t\t"),
                            _vm.citySort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "city")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.citySort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "city")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("\n\t\t\t\t\t\t\t\tState\n\t\t\t\t\t\t\t\t"),
                            _vm.stateSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "state")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.stateSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "state")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(" Action ")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.configurationData, function(referenceData) {
                        return [
                          _c(
                            "tr",
                            {
                              key: referenceData._id,
                              staticClass: "md-table-row"
                            },
                            [
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c("md-checkbox", {
                                      attrs: { value: referenceData._id },
                                      on: {
                                        change: function($event) {
                                          return _vm.singleRowCheck()
                                        }
                                      },
                                      model: {
                                        value: _vm.singleCheckBox,
                                        callback: function($$v) {
                                          _vm.singleCheckBox = $$v
                                        },
                                        expression: "singleCheckBox"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.name
                                          ? referenceData.name
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.url
                                          ? referenceData.url
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayCategory(
                                          referenceData.category
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.market
                                          ? referenceData.market
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.status
                                          ? referenceData.status
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.country
                                          ? referenceData.country
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.state
                                          ? referenceData.state
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.region
                                          ? referenceData.region
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.city
                                          ? referenceData.city
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              "reference-" +
                                              _vm.$route.params.reference +
                                              "/" +
                                              referenceData._id +
                                              "/edit",
                                            params: {
                                              reference:
                                                _vm.$route.params.reference,
                                              id: referenceData._id
                                            }
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _vm.configurationData.length == 0
                        ? [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { colspan: "11", align: "center" } },
                                [
                                  _c("md-empty-state", {
                                    staticClass: "table-no-record",
                                    attrs: {
                                      "md-label": "No Record Found",
                                      "md-description": ""
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference == "roles"
                ? _c(
                    "md-table",
                    { staticClass: "roles-table" },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c(
                            "md-table-head",
                            { staticClass: "card-header" },
                            [
                              _c("md-checkbox", {
                                staticClass: "checkBox-visible",
                                attrs: { value: true },
                                on: {
                                  change: function($event) {
                                    return _vm.checkAllData()
                                  }
                                },
                                model: {
                                  value: _vm.checkAll,
                                  callback: function($$v) {
                                    _vm.checkAll = $$v
                                  },
                                  expression: "checkAll"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Role\n\t\t\t\t\t\t\t\t"),
                            _vm.roleSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "role")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.roleSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "role")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tDescription\n\t\t\t\t\t\t\t\t"
                            ),
                            _vm.descriptionSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn(
                                        "asc",
                                        "description"
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.descriptionSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn(
                                        "desc",
                                        "description"
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(" Action ")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.configurationData, function(referenceData) {
                        return [
                          _c(
                            "tr",
                            {
                              key: referenceData._id,
                              staticClass: "md-table-row"
                            },
                            [
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c("md-checkbox", {
                                      attrs: { value: referenceData._id },
                                      on: {
                                        change: function($event) {
                                          return _vm.singleRowCheck()
                                        }
                                      },
                                      model: {
                                        value: _vm.singleCheckBox,
                                        callback: function($$v) {
                                          _vm.singleCheckBox = $$v
                                        },
                                        expression: "singleCheckBox"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.role
                                          ? referenceData.role
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.description
                                          ? referenceData.description
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              "reference-" +
                                              _vm.$route.params.reference +
                                              "/" +
                                              referenceData._id +
                                              "/edit",
                                            params: {
                                              reference:
                                                _vm.$route.params.reference,
                                              id: referenceData._id
                                            }
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _vm.configurationData.length == 0
                        ? [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { colspan: "4", align: "center" } },
                                [
                                  _c("md-empty-state", {
                                    staticClass: "table-no-record",
                                    attrs: {
                                      "md-label": "No Record Found",
                                      "md-description": ""
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference == "coaching-templates"
                ? _c(
                    "md-table",
                    { staticClass: "coaching-templates-table" },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c(
                            "md-table-head",
                            { staticClass: "card-header" },
                            [
                              _c("md-checkbox", {
                                staticClass: "checkBox-visible",
                                attrs: { value: true },
                                on: {
                                  change: function($event) {
                                    return _vm.checkAllData()
                                  }
                                },
                                model: {
                                  value: _vm.checkAll,
                                  callback: function($$v) {
                                    _vm.checkAll = $$v
                                  },
                                  expression: "checkAll"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Title")
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Content")
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Action")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.filteredCoachingTemplates, function(
                        referenceData
                      ) {
                        return [
                          _c(
                            "tr",
                            {
                              key: referenceData._id,
                              staticClass: "md-table-row"
                            },
                            [
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c("md-checkbox", {
                                      attrs: { value: referenceData._id },
                                      on: {
                                        change: function($event) {
                                          return _vm.singleRowCheck()
                                        }
                                      },
                                      model: {
                                        value: _vm.singleCheckBox,
                                        callback: function($$v) {
                                          _vm.singleCheckBox = $$v
                                        },
                                        expression: "singleCheckBox"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.name
                                          ? referenceData.name
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.content
                                          ? referenceData.content
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              "reference-" +
                                              _vm.$route.params.reference +
                                              "/" +
                                              referenceData._id +
                                              "/edit",
                                            params: {
                                              reference:
                                                _vm.$route.params.reference,
                                              id: referenceData._id
                                            }
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _vm.configurationData.length == 0
                        ? [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { colspan: "6", align: "center" } },
                                [
                                  _c("md-empty-state", {
                                    staticClass: "table-no-record",
                                    attrs: {
                                      "md-label": "No Record Found",
                                      "md-description": ""
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference == "skills"
                ? _c(
                    "md-table",
                    { staticClass: "member-table" },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c(
                            "md-table-head",
                            { staticClass: "card-header" },
                            [
                              _c("md-checkbox", {
                                staticClass: "checkBox-visible",
                                attrs: { value: true },
                                on: {
                                  change: function($event) {
                                    return _vm.checkAllData()
                                  }
                                },
                                model: {
                                  value: _vm.checkAll,
                                  callback: function($$v) {
                                    _vm.checkAll = $$v
                                  },
                                  expression: "checkAll"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Skills\n\t\t\t\t\t\t\t\t"),
                            _vm.skillsSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "skills")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.skillsSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "skills")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(" Action ")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.configurationData, function(referenceData) {
                        return [
                          _c(
                            "tr",
                            {
                              key: referenceData._id,
                              staticClass: "md-table-row"
                            },
                            [
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c("md-checkbox", {
                                      attrs: { value: referenceData._id },
                                      on: {
                                        change: function($event) {
                                          return _vm.singleRowCheck()
                                        }
                                      },
                                      model: {
                                        value: _vm.singleCheckBox,
                                        callback: function($$v) {
                                          _vm.singleCheckBox = $$v
                                        },
                                        expression: "singleCheckBox"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.skills
                                          ? referenceData.skills
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              "reference-" +
                                              _vm.$route.params.reference +
                                              "/" +
                                              referenceData._id +
                                              "/edit",
                                            params: {
                                              reference:
                                                _vm.$route.params.reference,
                                              id: referenceData._id
                                            }
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _vm.configurationData.length == 0
                        ? [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { colspan: "3", align: "center" } },
                                [
                                  _c("md-empty-state", {
                                    staticClass: "table-no-record",
                                    attrs: {
                                      "md-label": "No Record Found",
                                      "md-description": ""
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference == "filter-words"
                ? _c(
                    "md-table",
                    { staticClass: "member-table" },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c(
                            "md-table-head",
                            { staticClass: "card-header" },
                            [
                              _c("md-checkbox", {
                                staticClass: "checkBox-visible",
                                attrs: { value: true },
                                on: {
                                  change: function($event) {
                                    return _vm.checkAllData()
                                  }
                                },
                                model: {
                                  value: _vm.checkAll,
                                  callback: function($$v) {
                                    _vm.checkAll = $$v
                                  },
                                  expression: "checkAll"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Filter Words\n\t\t\t\t\t\t\t\t"),
                            _vm.wordSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "word")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.wordSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "word")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(" Action ")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.configurationData, function(referenceData) {
                        return [
                          _c(
                            "tr",
                            {
                              key: referenceData._id,
                              staticClass: "md-table-row"
                            },
                            [
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c("md-checkbox", {
                                      attrs: { value: referenceData._id },
                                      on: {
                                        change: function($event) {
                                          return _vm.singleRowCheck()
                                        }
                                      },
                                      model: {
                                        value: _vm.singleCheckBox,
                                        callback: function($$v) {
                                          _vm.singleCheckBox = $$v
                                        },
                                        expression: "singleCheckBox"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.word
                                          ? _vm.changeTxt(referenceData.word)
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              "reference-" +
                                              _vm.$route.params.reference +
                                              "/" +
                                              referenceData._id +
                                              "/edit",
                                            params: {
                                              reference:
                                                _vm.$route.params.reference,
                                              id: referenceData._id
                                            }
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _vm.configurationData.length == 0
                        ? [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { colspan: "3", align: "center" } },
                                [
                                  _c("md-empty-state", {
                                    staticClass: "table-no-record",
                                    attrs: {
                                      "md-label": "No Record Found",
                                      "md-description": ""
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference == "protopia-owner"
                ? _c(
                    "md-table",
                    { staticClass: "member-table" },
                    [
                      _c(
                        "md-table-row",
                        [
                          _c(
                            "md-table-head",
                            { staticClass: "card-header" },
                            [
                              _c("md-checkbox", {
                                staticClass: "checkBox-visible",
                                attrs: { value: true },
                                on: {
                                  change: function($event) {
                                    return _vm.checkAllData()
                                  }
                                },
                                model: {
                                  value: _vm.checkAll,
                                  callback: function($$v) {
                                    _vm.checkAll = $$v
                                  },
                                  expression: "checkAll"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Owner Name\n\t\t\t\t\t\t\t\t"),
                            _vm.ownerNameSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "ownerName")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ownerNameSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("desc", "ownerName")
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v("Owner Email\n\t\t\t\t\t\t\t\t"),
                            _vm.ownerEmailSort === "desc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/down-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn("asc", "ownerEmail")
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ownerEmailSort === "asc"
                              ? _c("img", {
                                  attrs: {
                                    src:
                                      "https://storage.googleapis.com/protopia/app/web/up-arrow.png"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.sortColumn(
                                        "desc",
                                        "ownerEmail"
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("md-table-head", { staticClass: "card-header" }, [
                            _vm._v(" Action ")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.configurationData, function(referenceData) {
                        return [
                          _c(
                            "tr",
                            {
                              key: referenceData._id,
                              staticClass: "md-table-row"
                            },
                            [
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c("md-checkbox", {
                                      attrs: { value: referenceData._id },
                                      on: {
                                        change: function($event) {
                                          return _vm.singleRowCheck()
                                        }
                                      },
                                      model: {
                                        value: _vm.singleCheckBox,
                                        callback: function($$v) {
                                          _vm.singleCheckBox = $$v
                                        },
                                        expression: "singleCheckBox"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.name
                                          ? referenceData.name
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        referenceData.email
                                          ? referenceData.email
                                          : "-"
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "md-table-cell" }, [
                                _c(
                                  "div",
                                  { staticClass: "md-table-cell-container" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              "reference-" +
                                              _vm.$route.params.reference +
                                              "/" +
                                              referenceData._id +
                                              "/edit",
                                            params: {
                                              reference:
                                                _vm.$route.params.reference,
                                              id: referenceData._id
                                            }
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-edit" })]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ]
                      }),
                      _vm._v(" "),
                      _vm.configurationData.length == 0
                        ? [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { colspan: "3", align: "center" } },
                                [
                                  _c("md-empty-state", {
                                    staticClass: "table-no-record",
                                    attrs: {
                                      "md-label": "No Record Found",
                                      "md-description": ""
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference == "wizard-content"
                ? _c("configuration-wizard")
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference == "interests"
                ? _c("configuration-interests")
                : _vm._e(),
              _vm._v(" "),
              _vm.$route.params.reference != "interests" &&
              _vm.$route.params.reference != "wizard-content"
                ? _c(
                    "div",
                    { staticClass: "w-100 text-center mt-20" },
                    [
                      _vm.showLoadMore()
                        ? _c(
                            "md-button",
                            {
                              staticClass:
                                "md-mini btnplain capitalize card-header",
                              on: {
                                click: function($event) {
                                  return _vm.loadDataWithApi(_vm.searchData)
                                }
                              }
                            },
                            [_vm._v("Load More")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input", {
                ref: "file",
                staticStyle: { display: "none" },
                attrs: { type: "file", accept: ".csv", id: "upload-sheet" },
                on: { change: _vm.handleUpload }
              }),
              _vm._v(" "),
              _vm.$route.params.reference != "interests" &&
              _vm.$route.params.reference != "wizard-content"
                ? _c(
                    "div",
                    { staticClass: "button-section button-section-style" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass:
                            "md-raised md-accent md-white-color capitalize",
                          attrs: {
                            disabled: _vm.disabledBtn == 1 ? true : false
                          }
                        },
                        [
                          _c("md-dialog-confirm", {
                            attrs: {
                              "md-active": _vm.allDeleteBtn,
                              "md-title": "Delete Confirmation",
                              "md-content": _vm.setContentForAllDelete
                            },
                            on: {
                              "update:mdActive": function($event) {
                                _vm.allDeleteBtn = $event
                              },
                              "update:md-active": function($event) {
                                _vm.allDeleteBtn = $event
                              },
                              "md-confirm": _vm.removeAllRecord
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "md-remove md-remove-all",
                              on: {
                                click: function($event) {
                                  _vm.allDeleteBtn = true
                                }
                              }
                            },
                            [_vm._v("Delete All")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass:
                            "md-raised md-accent md-white-color capitalize",
                          attrs: { disabled: _vm.disabled == 1 ? true : false }
                        },
                        [
                          _c("md-dialog-confirm", {
                            attrs: {
                              "md-active": _vm.active,
                              "md-title": "Delete Confirmation",
                              "md-content": _vm.setContent
                            },
                            on: {
                              "update:mdActive": function($event) {
                                _vm.active = $event
                              },
                              "update:md-active": function($event) {
                                _vm.active = $event
                              },
                              "md-confirm": _vm.removeRecord
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "md-remove",
                              on: {
                                click: function($event) {
                                  _vm.active = true
                                }
                              }
                            },
                            [_vm._v("Delete")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$route.params.reference != "protopia-owner" &&
                      _vm.$route.params.reference != "wizard-content"
                        ? _c(
                            "md-button",
                            {
                              staticClass:
                                "md-raised md-accent md-white-color capitalize",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.file.click()
                                }
                              }
                            },
                            [_vm._v("Load")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$route.params.reference != "protopia-owner" &&
                      _vm.$route.params.reference != "wizard-content"
                        ? _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.CSVLink,
                                title: "Download sample file",
                                download: ""
                              }
                            },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-fab md-mini md-white-color downloadBtn"
                                },
                                [_c("i", { staticClass: "fa fa-download" })]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b53e414", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b53e414","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Configuration.vue
// module id = null
// module chunks = 